import { render, staticRenderFns } from "./BaseStyledMenu.vue?vue&type=template&id=09e9ff6a&scoped=true"
import script from "./BaseStyledMenu.vue?vue&type=script&lang=ts"
export * from "./BaseStyledMenu.vue?vue&type=script&lang=ts"
import style0 from "./BaseStyledMenu.vue?vue&type=style&index=0&id=09e9ff6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9ff6a",
  null
  
)

export default component.exports